import { Injectable } from '@angular/core';
import { LocalStorageService } from '@cdk/browser';

const shownRemindersServiceFactory = (storage: LocalStorageService): PersistentSetService<number> =>
  new PersistentSetService<number>(storage, 'wfm-reminders');

@Injectable({
  providedIn: 'root',
  useFactory: shownRemindersServiceFactory,
  deps: [LocalStorageService],
})
export class PersistentSetService<T> {
  constructor(private readonly storage: LocalStorageService, private readonly storageKey: string) {}

  has(key: T): boolean {
    const reminders = this.getReminders();
    return reminders.has(key);
  }

  set(key: T): void {
    const reminders = this.getReminders();
    reminders.add(key);
    this.saveReminders(reminders);
  }

  deleteMany(predicate: (key: T) => boolean): void {
    const reminders = this.getReminders();
    if (!reminders.size) {
      return;
    }

    const toDelete = [...reminders.keys()].filter(predicate);
    toDelete.forEach(time => reminders.delete(time));
    this.saveReminders(reminders);
  }

  private getReminders(): Set<T> {
    return new Set(this.storage.getItem(this.storageKey) ?? []);
  }

  private saveReminders(reminders: Set<T>): void {
    this.storage.setItem(this.storageKey, [...reminders.values()]);
  }
}
